import { darkColors, lightColors, theme } from '@tryhackme/thm-ui-components';
import type React from 'react';
import type { ThemeColorMode } from 'src/common/enums';
import { ThemeProvider } from 'styled-components';
const colors = {
  dark: darkColors,
  light: lightColors
};
const ForceTheme = ({
  themeMode,
  children
}: {
  themeMode: ThemeColorMode;
  children: React.ReactNode;
}) => <ThemeProvider theme={{
  ...theme,
  colors: colors[themeMode]
}} data-sentry-element="ThemeProvider" data-sentry-component="ForceTheme" data-sentry-source-file="index.tsx">{children}</ThemeProvider>;
export { ForceTheme };